export function objectKeysOnlyOfType<T extends Record<string, unknown>, V> (
    object: T,
    predicate: (value: unknown) => value is V
): { [K in keyof T as T[K] extends V ? K : never]: V } {
    const result = {} as { [K in keyof T as T[K] extends V ? K : never]: V }

    for (const key in object) {
        if (predicate(object[key])) {
            result[key] = object[key] as V
        }
    }

    return result
}

export function isString (value: unknown): value is string {
    return typeof value === 'string'
}

export function isObject (value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export function isEmpty (value: unknown): boolean {
    return value === '' || value == null
}
